import { useEffect } from "react";
import { useOutletContext, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Pages from "@client.enums/pages";

const Reports = () => {
  const [setTopBarTitle] = useOutletContext();
  const { t } = useTranslation();
  const navigation = useNavigate();

  useEffect(() => {
    setTopBarTitle(t("components.NavigationBar.reports"));
    navigation(Pages.ReportsCompany);
  }, [setTopBarTitle, navigation, t]);

  return null;
};

export default Reports;
